import { render, staticRenderFns } from "./PontaDeEstoque.vue?vue&type=template&id=0c2fa824&scoped=true"
import script from "./PontaDeEstoque.vue?vue&type=script&lang=js"
export * from "./PontaDeEstoque.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c2fa824",
  null
  
)

export default component.exports